module.exports = __webpack_public_path__ + "static/media/drop-slide-7.6c7de638.png";